import { render, staticRenderFns } from "./field-star-rating.vue?vue&type=template&id=c8b74be8&scoped=true&"
import script from "./field-star-rating.vue?vue&type=script&lang=js&"
export * from "./field-star-rating.vue?vue&type=script&lang=js&"
import style0 from "./field-star-rating.vue?vue&type=style&index=0&id=c8b74be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b74be8",
  null
  
)

export default component.exports